(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["grandpa-playlist"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('grandpa-playlist-widget')) return;

    function loadSpotifyApi(callback) {
      if (window.__gpSpotifyIFrameAPI) {
        callback(window.__gpSpotifyIFrameAPI);
        return;
      }

      window.__gpSpotifyReadyQueue = window.__gpSpotifyReadyQueue || [];
      window.__gpSpotifyReadyQueue.push(callback);

      if (window.__gpSpotifyScriptAdded) return;
      window.__gpSpotifyScriptAdded = true;

      window.onSpotifyIframeApiReady = (IFrameAPI) => {
        window.__gpSpotifyIFrameAPI = IFrameAPI;
        window.__gpSpotifyReadyQueue.forEach((cb) => cb(IFrameAPI));
        window.__gpSpotifyReadyQueue = [];
      };

      const script = document.createElement('script');
      script.src = 'https://open.spotify.com/embed/iframe-api/v1';
      script.async = true;
      document.head.appendChild(script);
    }

    class GrandpaPlaylistWidget extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-playlist-toggle]');
        this.mount = this.querySelector('[data-spotify-mount]');
        this.uri = this.getAttribute('data-spotify-uri');

        if (!this.button) return;

        this.button.addEventListener('click', () => this.toggle());

        document.addEventListener('grandpa-playlist:play', (event) => {
          if (event.detail !== this) this.pause();
        });

        if (!this.mount || !this.uri) return;

        loadSpotifyApi((IFrameAPI) => {
          IFrameAPI.createController(
            this.mount,
            { uri: this.uri, width: '300', height: '80' },
            (EmbedController) => {
              this.controller = EmbedController;
              this.controller.addListener('playback_update', (event) => {
                this.setPlaying(!event.data.isPaused);
              });
            }
          );
        });
      }

      toggle() {
        if (!this.controller) return;

        if (!this.classList.contains('is-playing')) {
          document.dispatchEvent(new CustomEvent('grandpa-playlist:play', { detail: this }));
        }

        this.controller.togglePlay();
      }

      pause() {
        if (this.controller) this.controller.pause();
      }

      setPlaying(isPlaying) {
        this.classList.toggle('is-playing', isPlaying);
        if (this.button) this.button.setAttribute('aria-pressed', String(isPlaying));
      }
    }

    customElements.define('grandpa-playlist-widget', GrandpaPlaylistWidget);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["yg-trust-item"] && !Shopify.designMode) return;
  try {
    // Desktop only: Escape closes the small hover/focus tooltip by blurring
  // whatever's focused inside .yg-trust__item. The mobile modal has its own
  // Escape handling in assets/yg-trust-modal.js, since its open/close state
  // isn't focus-driven.
  if (!window.ygTrustTooltipsBound) {
    window.ygTrustTooltipsBound = true;

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const active = document.activeElement;
      if (active instanceof HTMLElement && active.closest('.yg-trust__item')) active.blur();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
